export default {
  butt: {
    hand: {
      null: {
        null: {
          null: {
            null: {
              value: 0.0,
              explain:
                "Getting your butt fingered poses a VERY LOW risk for HIV."
            }
          }
        }
      }
    },
    mouth: {
      null: {
        null: {
          null: {
            null: {
              value: 0.0,
              explain:
                "Getting a rim job (oral sex on butt) poses a VERY LOW risk for HIV."
            }
          }
        }
      }
    },
    penis: {
      condom: {
        null: {
          null: {
            null: {
              value: 39.0,
              explain:
                "You’re the BOTTOM partner during ANAL sex, your partner has a detectable viral load, and you use condoms. Good job using condoms! But, your partner’s detectable viral load can still put you at risk for HIV. So, use more than one form of protection that IS under your control.  Add or subtract some factors to see how your HIV risk changes."
            },
            sti: {
              value: 102.0,
              explain:
                "You’re the BOTTOM partner during ANAL sex, one of you has an STI, your partner has a detectable viral load, and you use condoms. Good job using condoms! However, this still poses a HIGH risk for HIV, because your partner’s detectable viral load plus certain STIs can increase HIV risk. So, use more than one form of protection that IS under your control. Add or subtract some factors to see how your HIV risk changes."
            }
          },
          uplus: {
            null: {
              value: 0.5,
              explain:
                "You’re the BOTTOM partner during ANAL sex, your partner is undetectable, and you use condoms. Great job! Using condoms and having a partner who is undetectable reduces your risk of HIV by a lot! But, you can't control your partner's viral load. So, use more than one form of protection that IS under your control. Add or subtract some factors to see how your HIV risk changes."
            },
            sti: {
              value: 0.5,
              explain:
                "You’re the BOTTOM partner during ANAL sex, one of you has an STI, your partner is undetectable, and you use condoms. Using condoms and having a partner who is undetectable reduces your risk of HIV by a lot. Great job! However, you can’t control your partner’s viral load and certain STIs can increase HIV risk. So, use more than one form of protection that IS under your control. Add or subtract some factors to see how your HIV risk changes."
            }
          }
        },
        prep: {
          null: {
            null: {
              value: 0.5,
              explain:
                "You’re the BOTTOM partner during ANAL sex, your partner has a detectable viral load, you take PrEP, and you use condoms. Great job! Using two layers of protection reduces your risk of HIV by a lot! Add or subtract some factors to see how your HIV risk changes."
            },
            sti: {
              value: 1.0,
              explain:
                "You’re the BOTTOM partner during ANAL sex, one of you has an STI, your partner has a detectable viral load, you take PrEP, and you use condoms. Great job! Using two layers of protection reduces your risk of HIV by a lot! However, certain STIs can increase HIV risk. Add or subtract some factors to see how your HIV risk changes."
            }
          },
          uplus: {
            null: {
              value: 0.5,
              explain:
                "You’re the BOTTOM partner during ANAL sex, your partner is undetectable, you take PrEP, and you use condoms. This poses a LOW risk for HIV. Great job! You’re doing everything you can to protect your sexual health! Add or subtract some factors to see how your HIV risk changes."
            },
            sti: {
              value: 0.5,
              explain:
                "You’re the BOTTOM partner during ANAL sex, one of you has an STI, your partner is undetectable, you take PrEP, and you use condoms.  This poses a LOW risk for HIV. Great job! You’re doing a lot to protect your sexual health! However, certain STIs can increase HIV risk. Subtract some factors to see how your HIV risk changes."
            }
          }
        }
      },
      null: {
        null: {
          null: {
            null: {
              value: 138.0,
              explain:
                "You’re the BOTTOM partner during ANAL sex, your partner has a detectable viral load, and you don’t use protection. This poses a HIGH risk for HIV because it is easier for HIV to enter the body and infect you if you’re not using protection, and your partner’s viral load can increase your HIV risk. So, use more than one form of protection that IS under your control. Add some factors to see how your HIV risk changes."
            },
            sti: {
              value: 366.0,
              explain:
                "You’re the BOTTOM partner during ANAL sex, one of you has an STI, your partner has a detectable viral load, and you don’t use protection.  This poses one of the HIGHEST risks for HIV because it is easier for HIV to enter the body and infect you if you’re not using protection, and your partner’s detectable viral load plus certain STIs can increase your HIV risk. So, use more than one form of protection that IS under your control. Add or subtract some factors to see how your HIV risk changes."
            }
          },
          uplus: {
            null: {
              value: 0.5,
              explain:
                "You’re the BOTTOM partner during ANAL sex, and your partner is undetectable. The medication your HIV-positive partner takes helps keep HIV from spreading. But, you can’t control your partner’s viral load. So, use more than one form of protection that IS under your control. Add or subtract some factors to see how your HIV risk changes."
            },
            sti: {
              value: 0.5,
              explain:
                "You’re the BOTTOM partner during ANAL sex, one of you has an STI, and your partner is undetectable. This puts you at risk for HIV. The medication your HIV-positive partner takes helps keep HIV from spreading. But, you can't control your partner's viral load, and certain STIs can increase HIV risk. So, use more than one form of protection that IS under your control. Add or subtract some factors to see how your HIV risk changes."
            }
          }
        },
        prep: {
          null: {
            null: {
              value: 1.0,
              explain:
                "You’re the BOTTOM partner during ANAL sex, your partner has a detectable viral load, and you take PrEP. Good job taking PrEP! But, your partner’s detectable viral load can still put you at risk for HIV. So, use more than one form of protection that IS under your control. Add or subtract some factors to see how your HIV risk changes."
            },
            sti: {
              value: 4.0,
              explain:
                "You’re the BOTTOM partner during ANAL sex, one of you has an STI, your partner has a detectable viral load, and you take PrEP. Good job taking PrEP! However, your partner’s detectable viral load plus certain STIs can still put you at risk for HIV. So, use more than one form of protection that IS under your control. Add or subtract some factors to see how your HIV risk changes."
            }
          },
          uplus: {
            null: {
              value: 0.5,
              explain:
                "You’re the BOTTOM partner during ANAL sex, your partner is undetectable, and you take PrEP. This poses a LOW risk for HIV. Great job! Taking PrEP and having a partner who is undetectable reduces your risk of HIV by a lot! But, you can't control your partner's viral load. So, use more than one form of protection that IS under your control. Add or subtract some factors to see how your HIV risk changes."
            },
            sti: {
              value: 0.5,
              explain:
                "You’re the BOTTOM partner during ANAL sex, one of you has an STI, your partner is undetectable, and you take PrEP. Taking PrEP and having a partner who is undetectable reduces your risk of HIV by a lot. Great job! However, you can’t control your partner’s viral load, and certain STIs can increase HIV risk. So, use more than one form of protection that IS under your control. Add or subtract some factors to see how your HIV risk changes."
            }
          }
        }
      }
    }
  },
  hand: {
    butt: {
      null: {
        null: {
          null: {
            null: {
              value: 0.0,
              explain:
                "Fingering your partner's butt poses a VERY LOW risk for HIV."
            }
          }
        }
      }
    },
    hand: {
      null: {
        null: {
          null: {
            null: {
              value: 0.0,
              explain:
                "Touching, like holding hands and cuddling, does not put you at risk for HIV. Try another combination!"
            }
          }
        }
      }
    },
    penis: {
      null: {
        null: {
          null: {
            null: {
              value: 0.0,
              explain:
                "Giving your partner a hand job poses a VERY LOW risk for HIV."
            }
          }
        }
      }
    },
    vagina: {
      null: {
        null: {
          null: {
            null: {
              value: 0.0,
              explain:
                "Fingering your partner's vagina poses a VERY LOW risk for HIV."
            }
          }
        }
      }
    }
  },
  mouth: {
    butt: {
      null: {
        null: {
          null: {
            null: {
              value: 0.0,
              explain:
                "Giving your partner a rim job (oral sex on butt) poses a VERY LOW risk for HIV."
            }
          }
        }
      }
    },
    mouth: {
      null: {
        null: {
          null: {
            null: {
              value: 0.0,
              explain:
                "Kissing does not put you at risk for HIV. Try another combination!"
            }
          }
        }
      }
    },
    penis: {
      null: {
        null: {
          null: {
            null: {
              value: 0.0,
              explain:
                "Giving your partner a blowjob (oral sex on penis) poses a VERY LOW risk for HIV."
            }
          }
        }
      }
    },
    vagina: {
      null: {
        null: {
          null: {
            null: {
              value: 0.0,
              explain:
                "Going down (oral sex) on a vagina poses a VERY LOW risk for HIV."
            }
          }
        }
      }
    }
  },
  penis: {
    butt: {
      condom: {
        null: {
          null: {
            null: {
              value: 4.0,
              explain:
                "You’re the TOP partner during ANAL sex, your partner has a detectable viral load, and you use condoms. Good job using condoms! But your partner’s detectable viral load can still put you at risk for HIV. So, use more than one form of protection that IS under your control.  Add or subtract some factors to see how your HIV risk changes."
            },
            sti: {
              value: 11.0,
              explain:
                "You’re the TOP partner during ANAL sex, one of you has an STI, your partner has a detectable viral load, and you use condoms. Good job using condoms! However, you can’t control your partner’s viral load and certain STIs can increase HIV risk. So, use more than one form of protection that IS under your control. Add or subtract some factors to see how your HIV risk changes."
            }
          },
          uplus: {
            null: {
              value: 0.5,
              explain:
                "You’re the TOP partner during ANAL sex, your partner is undetectable, and you use condoms. This poses a LOW risk for HIV. Great job! Using condoms and having a partner who is undetectable reduces your risk of HIV by a lot! But, you can't control your partner's viral load. So, use more than one form of protection that IS under your control. Add or subtract some factors to see how your HIV risk changes."
            },
            sti: {
              value: 0.5,
              explain:
                "You’re the TOP partner during ANAL sex, one of you has an STI, your partner is undetectable, and you use condoms. This poses a LOW risk for HIV. Using condoms and having a partner who is undetectable reduces your risk of HIV by a lot. Great job! However, you can’t control your partner’s viral load, and certain STIs can increase HIV risk. So, use more than one form of protection that IS under your control. Add or subtract some factors to see how your HIV risk changes."
            }
          }
        },
        prep: {
          null: {
            null: {
              value: 0.5,
              explain:
                "You’re the TOP partner during ANAL sex, your partner has a detectable viral load, you take PrEP, and you use condoms. This poses a LOW risk for HIV. Great job! Using two layers of protection reduces your risk of HIV by a lot! Add or subtract some factors to see how your HIV risk changes."
            },
            sti: {
              value: 0.5,
              explain:
                "You’re the TOP partner during ANAL sex, one of you has an STI, your partner has a detectable viral load, you take PrEP, and you use condoms. Great job! Using two layers of protection reduces your risk of HIV by a lot! However, certain STIs can increase HIV risk. Add or subtract some factors to see how your HIV risk changes."
            }
          },
          uplus: {
            null: {
              value: 0.5,
              explain:
                "You’re the TOP partner during ANAL sex, your partner is undetectable, you take PrEP, and you use condoms. This poses a LOW risk for HIV. Great job! You’re doing everything you can to protect your sexual health! Add or subtract some factors to see how your HIV risk changes."
            },
            sti: {
              value: 0.5,
              explain:
                "You’re the TOP partner during ANAL sex, one of you has an STI, your partner is undetectable, you take PrEP, and you use condoms. This poses a LOW risk for HIV. Great job! You’re doing a lot to protect your sexual health! However, certain STIs can increase HIV risk. Subtract some factors to see how your HIV risk changes."
            }
          }
        }
      },
      null: {
        null: {
          null: {
            null: {
              value: 11.0,
              explain:
                "You’re the TOP partner during ANAL sex, your partner has a detectable viral load, and you don’t use protection. Not using protection puts you at risk for HIV because it is easier for HIV to enter the body and infect you, and your partner’s viral load can increase your HIV risk. So, use more than one form of protection that IS under your control. Add some factors to see how your HIV risk changes."
            },
            sti: {
              value: 29.0,
              explain:
                "You’re the TOP partner during ANAL sex, one of you has an STI, your partner has a detectable viral load, and you don’t use protection. Not using protection puts you at risk for HIV because it is easier for HIV to enter the body and infect you, and your partner’s detectable viral load plus certain STIs that can increase your HIV risk. So, use more than one form of protection that IS under your control. Add or subtract some factors to see how your HIV risk changes."
            }
          },
          uplus: {
            null: {
              value: 0.5,
              explain:
                "You’re the TOP partner during ANAL sex, and your partner is undetectable. This poses a LOW risk for HIV. The medication your HIV-positive partner takes helps keep HIV from spreading. But, you can’t control your partner’s viral load. So, use more than one form of protection that IS under your control. Add or subtract some factors to see how your HIV risk changes."
            },
            sti: {
              value: 0.5,
              explain:
                "You’re the TOP partner during ANAL sex, one of you has an STI, and your partner is undetectable. The medication your HIV-positive partner takes helps keep HIV from spreading. But, you can't control your partner's viral load, and certain STIs can increase HIV risk. So, use more than one form of protection that IS under your control. Add or subtract some factors to see how your HIV risk changes."
            }
          }
        },
        prep: {
          null: {
            null: {
              value: 0.5,
              explain:
                "You’re the TOP partner during ANAL sex, your partner has a detectable viral load, and you take PrEP. Good job taking PrEP! But, your partner’s detectable viral load can still put you at risk for HIV. So, use more than one form of protection that IS under your control. Add or subtract some factors to see how your HIV risk changes."
            },
            sti: {
              value: 0.5,
              explain:
                "You’re the TOP partner during ANAL sex, one of you has an STI, your partner has a detectable viral load, and you take PrEP. Good job taking PrEP! However, your partner’s detectable viral load plus certain STIs can still put you at risk for HIV. So, use more than one form of protection that IS under your control. Add or subtract some factors to see how your HIV risk changes."
            }
          },
          uplus: {
            null: {
              value: 0.5,
              explain:
                "You’re the TOP partner during ANAL sex, your partner is undetectable, and you take PrEP. This poses a LOW risk for HIV. Great job! Taking PrEP and having a partner who is undetectable reduces your risk of HIV by a lot! But, you can't control your partner's viral load. So, use more than one form of protection that IS under your control. Add or subtract some factors to see how your HIV risk changes."
            },
            sti: {
              value: 0.5,
              explain:
                "You’re the TOP partner during ANAL sex, one of you has an STI, your partner is undetectable, and you take PrEP. This poses a LOW risk for HIV. Taking PrEP and having a partner who is undetectable reduces your risk of HIV by a lot. Great job! However, you can’t control your partner’s viral load, and certain STIs can increase HIV risk. So, use more than one form of protection that IS under your control.  Add or subtract some factors to see how your HIV risk changes."
            }
          }
        }
      }
    },
    hand: {
      null: {
        null: {
          null: {
            null: {
              value: 0.0,
              explain: "Getting a hand job poses a VERY LOW risk for HIV."
            }
          }
        }
      }
    },
    mouth: {
      null: {
        null: {
          null: {
            null: {
              value: 0.0,
              explain:
                "Getting a blowjob (oral sex on penis) poses a VERY LOW risk for HIV."
            }
          }
        }
      }
    },
    penis: {
      null: {
        null: {
          null: {
            null: {
              value: 0.0,
              explain:
                "Grinding, or rubbing your penis and your partner's penis together, poses a VERY LOW risk for HIV."
            }
          }
        }
      }
    },
    vagina: {
      condom: {
        null: {
          null: {
            null: {
              value: 1.0,
              explain:
                "You’re the TOP partner during VAGINAL sex, your partner has a detectable viral load, and you use condoms. Good job using condoms! But, your partner’s detectable viral load can still put you at risk for HIV. So, use more than one form of protection that IS under your control.  Add or subtract some factors to see how your HIV risk changes."
            },
            sti: {
              value: 2.0,
              explain:
                "You’re the TOP partner during VAGINAL sex, one of you has an STI, your partner has a detectable viral load, and you use condoms. Good job using condoms! However, your partner’s detectable viral load plus certain STIs can still put you at risk for HIV. So, use more than one form of protection that IS under your control. Add or subtract some factors to see how your HIV risk changes."
            }
          },
          uplus: {
            null: {
              value: 0.5,
              explain:
                "You’re the TOP partner during VAGINAL sex, your partner is undetectable, and you use condoms. This poses a LOW risk for HIV. Great job! Using condoms and having a partner who is undetectable reduces your risk of HIV by a lot! But, you can't control your partner's viral load. So, use more than one form of protection that IS under your control. Add or subtract some factors to see how your HIV risk changes."
            },
            sti: {
              value: 0.5,
              explain:
                "You’re the TOP partner during VAGINAL sex, one of you has an STI, your partner is undetectable, and you use condoms. This poses a LOW risk for HIV. Using condoms and having a partner who is undetectable reduces your risk of HIV by a lot. Great job! However, you can’t control your partner’s viral load, and certain STIs can increase HIV risk. So, use more than one form of protection that IS under your control. Add or subtract some factors to see how your HIV risk changes."
            }
          }
        },
        prep: {
          null: {
            null: {
              value: 0.5,
              explain:
                "You’re the TOP partner during VAGINAL sex, your partner has a detectable viral load, you take PrEP, and you use condoms. This poses a LOW risk for HIV. Great job! Using two layers of protection reduces your risk of HIV by a lot! Add or subtract some factors to see how your HIV risk changes."
            },
            sti: {
              value: 0.5,
              explain:
                "You’re the TOP partner during VAGINAL sex, one of you has an STI, your partner has a detectable viral load, you take PrEP, and you use condoms. This poses a LOW risk for HIV. Great job! Using two layers of protection reduces your risk of HIV by a lot! However, certain STIs can increase HIV risk. Add or subtract some factors to see how your HIV risk changes."
            }
          },
          uplus: {
            null: {
              value: 0.5,
              explain:
                "You’re the TOP partner during VAGINAL sex, your partner is undetectable, you take PrEP, and you use condoms. This poses a LOW risk for HIV. Great job! You’re doing everything you can to protect your sexual health! Add or subtract some factors to see how your HIV risk changes."
            },
            sti: {
              value: 0.5,
              explain:
                "You’re the TOP partner during VAGINAL sex, one of you has an STI, your partner is undetectable, you take PrEP, and you use condoms.  This poses a LOW risk for HIV. Great job! You’re doing a lot to protect your sexual health! However, certain STIs can increase HIV risk. Subtract some factors to see how your HIV risk changes."
            }
          }
        }
      },
      null: {
        null: {
          null: {
            null: {
              value: 4.0,
              explain:
                "You’re the TOP partner during VAGINAL sex, your partner has a detectable viral load, and you don’t use protection. Not using protection puts you at risk for HIV because it is easier for HIV to enter the body and infect you, and your partner’s viral load can increase your HIV risk. So, use more than one form of protection that IS under your control. Add some factors to see how your HIV risk changes."
            },
            sti: {
              value: 11.0,
              explain:
                "You’re the TOP partner during VAGINAL sex, one of you has an STI, your partner has a detectable viral load, and you don’t use protection. Not using protection puts you at risk for HIV because it is easier for HIV to enter the body and infect you, and your partner’s detectable viral load plus certain STIs can increase your HIV risk. So, use more than one form of protection that IS under your control. Add or subtract some factors to see how your HIV risk changes."
            }
          },
          uplus: {
            null: {
              value: 0.5,
              explain:
                "You’re the TOP partner during VAGINAL sex, and your partner is undetectable. This poses a LOW risk for HIV.  The medication your HIV-positive partner takes helps keep HIV from spreading. But, you can’t control your partner’s viral load. So, use more than one form of protection that IS under your control. Add or subtract some factors to see how your HIV risk changes."
            },
            sti: {
              value: 0.5,
              explain:
                "You’re the TOP partner during VAGINAL sex, one of you has an STI, and your partner is undetectable. This poses a LOW risk for HIV. The medication your HIV-positive partner takes helps keep HIV from spreading. But, you can't control your partner's viral load, and certain STIs can increase HIV risk. So, use more than one form of protection that IS under your control. Add or subtract some factors to see how your HIV risk changes."
            }
          }
        },
        prep: {
          null: {
            null: {
              value: 0.5,
              explain:
                "You’re the TOP partner during VAGINAL sex, your partner has a detectable viral load, and you take PrEP. This poses a LOW risk for HIV. Good job taking PrEP! But, your partner’s detectable viral load can still put you at risk for HIV. So, use more than one form of protection that IS under your control. Add or subtract some factors to see how your HIV risk changes."
            },
            sti: {
              value: 0.5,
              explain:
                "You’re the TOP partner during VAGINAL sex, one of you has an STI, your partner has a detectable viral load, and you take PrEP. Good job taking PrEP! However, your partner’s detectable viral load plus certain STIs can still put you at risk for HIV. So, use more than one form of protection that IS under your control. Add or subtract some factors to see how your HIV risk changes."
            }
          },
          uplus: {
            null: {
              value: 0.5,
              explain:
                "You’re the TOP partner during VAGINAL sex, your partner is undetectable, and you take PrEP. This poses a LOW risk for HIV. Great job! Taking PrEP and having a partner who is undetectable reduces your risk of HIV by a lot! But, you can't control your partner's viral load, So, use more than one form of protection that IS under your control. Add or subtract some factors to see how your HIV risk changes."
            },
            sti: {
              value: 0.5,
              explain:
                "You’re the TOP partner during VAGINAL sex, one of you has an STI, your partner is undetectable, and you take PrEP. This poses a LOW risk for HIV. Taking PrEP and having a partner who is undetectable reduces your risk of HIV by a lot. Great job! However, you can’t control your partner’s viral load, and certain STIs can increase HIV risk. So, use more than one form of protection that IS under your control. Add or subtract some factors to see how your HIV risk changes."
            }
          }
        }
      }
    }
  }
};

//  Copyright © 2018 by Northwestern University. All Rights Reserved.
